import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Typography,
    Tabs,
    Tab,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    TextField,
    Grid,
    FormHelperText,
    Divider,
    Checkbox,
    FormGroup,
    FormControlLabel,
    InputAdornment,
    ListSubheader,
    Chip,
    ListItemText
} from '@mui/material';

import dayjs from 'dayjs';

import { grey } from '@mui/material/colors';

import { useFormik } from 'formik';

import { useAppContextFeatures } from '../../../context/AppContext';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useTranslations } from '../../../hooks/useTranslations';

import { useDocumentValidation } from "../../../hooks/api/useDocumentValidation"
import { CommonIcons, icons } from '../../common/CommonIcons';

import { initialValues, validationSchema } from '../../../schema/documents/validation/verifyTransferInSchema';

import { useSystemUtils } from '../../../hooks/useSystemUtils';

import DatePickerComponent from '../../common/DatePickerComponent';

export default function VerifyInTransferNew(
      {
          row,
          rackData,
          documentType,
          targetType,
          actionType,
          handleOnSuccess,
      }
) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { promptMessage } = useSystemPrompt()
    const { setSystemLoading } = useAppContextFeatures()
    const { formatDateTimeDisplay } = useSystemUtils();

    const {
        performVerifyTransferIn
    } = useDocumentValidation({ documentType, targetType, actionType })

    // const [ isTrackBatch, setIsTrackBatch ] = useState(false)

    const [dataVerifyOut, setDataVerifyOut] = useState(row?.verify_out_uids ? row.verify_out_uids: [])
    const [dataVerifyTransferIn, setDataVerifyTransferIn] = useState(row?.verify_in_uids ? row.verify_in_uids: [])

    const {
        document_id: documentId,
        unverify_in_qty: unVerifyInQty
    } = row

    // console.log('row', row)

    const onSubmit = async (currentValues) => {

        setSystemLoading(true);

        try {

            let qtyRequired = parseInt(currentValues?.verifyQty?.value, 10)
            let searchUids = dataVerifyOut.filter(i => i.id === currentValues?.verifyOut?.id)

            // getting the no of uids required
            let itemUids = [];

            for (let i = 0; i < qtyRequired; i += 1) {

                let a = searchUids[0];

                if (i < (a.uids_list.length)) {
                    itemUids.push(a.uids_list[i])
                }

            }

            // [
            //     {
            //         "doc_item_id": "8983",
            //         "verify_transfer_in": {
            //             "slot_id": "34",
            //             "item_uids": [
            //                 "9821"
            //             ]
            //         }
            //     }
            // ]

            let item = {
                doc_item_id: currentValues?.docItemId,
                verify_transfer_in: {
                    slot_id: currentValues?.slotId,
                    item_uids: itemUids,
                }
            }

            // item = {
            //     ...item,
            //     custom_batch_no: currentValues?.verifyOut?.customBatchNo,
            //     expiry_date: currentValues?.verifyOut?.expiryDate ? dayjs(currentValues.verifyOut.expiryDate).format("YYYY-MM-DD") : ""
            // }

            const data = [item]

            // console.log('veridyData', item, currentValues)

            const response = await performVerifyTransferIn({ id: documentId, data });

            promptMessage(true, t(`changesSaved`), response)

            // fetchData();
            if (handleOnSuccess) handleOnSuccess()

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const getSchema = () => {

        return validationSchema
    }

    const formik = useFormik({
        initialValues,
        validationSchema: getSchema(),
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, handleSubmit, setFieldValue } = formik;

    useEffect(() => {

        // assign the values into state formik
        setFieldValue(`code`, row?.code)
        setFieldValue(`docItemId`, row?.id)
        setFieldValue('itemName', row?.item_name)

        // maxQty
        setFieldValue(`verifyQty`, {
            ...values.verifyQty,
            value: "0",
            maxQty: parseFloat(unVerifyInQty)
        })

    }, [])

    const buildCompareId = (data) => {
        return `${data?.custom_batch_no ? data.custom_batch_no: ""}${data?.expiry_date ? data.expiry_date: ""}${data?.slot_id ? data.slot_id: ""}`
    }

    const getLatestVerifyOut = () => {

        let data = [];

        // loop for each available verify out saved
        dataVerifyOut.forEach((e1, index1) => {

            let compareId = buildCompareId(e1)

            let availableQty = parseFloat(e1?.qty_remain)
            // let totalUsageQty = 0;

            let totalInQty = 0;

            // loop for each verify In saved
            dataVerifyTransferIn.forEach((e2, index2) => {

                let compareId2 = buildCompareId(e2)
                let qty = parseFloat(e2?.qty_remain)

                console.log('compareId', compareId, compareId2)

                if (compareId === compareId2) { // found the matched need to deduct the available qty
                    // availableQty -= usageQty
                    // totalUsageQty += usageQty
                    totalInQty += qty
                }

            })

            data.push({
                ...e1,
                usageQty: totalInQty,
                allowQty: availableQty - parseFloat(totalInQty)
            })

        })

        return data


    }


    const getRacks = () => {

        return rackData
    }

    const getSlots = ({ rackId }) => {

        if (!rackId) return []

        const rack = rackData.filter(item => item.id === rackId)

        return rack && rack.length ? rack[0]._slots: []
    }

    const RenderRackSelect = () => {

        return (
              <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.rackId && Boolean(errors.rackId)}
              >
                  <InputLabel id="rack-label">{t('rack')}</InputLabel>
                  <Select
                        labelId="rack-label"
                        id="rack_id"
                        value={values?.rackId}
                        name={`rackId`}
                        label={t('rack')}
                        margin="dense"
                        size="small"
                        onChange={(event) => {
                            setFieldValue(`rackId`, event.target.value)
                        }}
                  >
                      {
                          getRacks().map((item, index) => <MenuItem key={index} value={item.id}>{item.rack_name}</MenuItem>)
                      }
                  </Select>
                  <FormHelperText>
                      {touched.rackId && errors.rackId}
                  </FormHelperText>
              </FormControl>
        )
    }

    const RenderSlotSelect = () => {

        // if(!values.rackId) return <></>

        const items = getSlots({ rackId: values?.rackId });

        return (
              <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.slotId && Boolean(errors.slotId)}
              >
                  <InputLabel id="documentType">{t('slot')}</InputLabel>
                  <Select
                        id="slotSelection"
                        value={values?.slotId}
                        name={t('slot')}
                        label="Slot"
                        margin="dense"
                        size="small"
                        onChange={(event) => {
                            setFieldValue(`slotId`, event.target.value)
                        }}
                  >
                      {
                          items.map((item, index) => <MenuItem key={index} value={item.id}>{item.name}</MenuItem>)
                      }
                  </Select>
                  <FormHelperText>
                      {touched.slotId && errors.slotId}
                  </FormHelperText>
              </FormControl>
        )

    }

    const RenderVerifyOutSelection = () => {

        return (
              <Grid container spacing={2}>
                  <Grid item md={6} sm={12} xs={12}>
                      {/* {JSON.stringify(values?.verifyOut)} */}
                      <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(errors?.verifyOut?.id)}
                      >
                          <InputLabel id="verifyOut">{t('savedData')}</InputLabel>
                          <Select
                                labelId="verifyOut"
                                label={t('savedData')}
                                name={`verifyOut.id`}
                                value={
                                    values?.verifyOut?.id ? values.verifyOut.id: ""
                                }
                                onChange={(event) => {

                                    // console.log('event', event.target.value)

                                    let verifyOutId = event.target.value

                                    let selectedRow = getLatestVerifyOut().filter(i => i.id === verifyOutId)

                                    if (selectedRow.length) {

                                        setFieldValue(`verifyOut`, {
                                            ...values.verifyOut,
                                            id: verifyOutId,
                                            value: "0",
                                            maxQty: parseFloat(selectedRow[0].allowQty),
                                            customBatchNo: selectedRow[0].custom_batch_no,
                                            expiryDate: selectedRow[0].expiry_date
                                        })

                                    }

                                }}
                                renderValue={(value) => {

                                    // let selectedRow = dataVerifyOut.filter(i => i.id === value)

                                    // if(selectedRow.length <= 0) return <></>

                                    return (
                                          <>
                                              <Chip
                                                    label={values?.verifyOut?.customBatchNo ? values.verifyOut.customBatchNo: '-'}
                                                    size="small"
                                              />
                                              <Chip
                                                    label={values?.verifyOut?.expiryDate ? (values.verifyOut.expiryDate): '-'}
                                                    size="small"
                                              />
                                          </>
                                    )
                                }}
                                sx={{
                                    textAlign: 'left',
                                }}
                                MenuProps={{
                                    MenuListProps: {
                                        sx: {
                                            py: 0
                                        },
                                    }
                                }}
                          >
                              <ListSubheader
                                    color={"primary"}
                                    sx={{ backgroundColor: (theme) => theme.palette.primary.main, px: 1.5, py: 0, m: 0 }}
                                    disableGutters
                              >
                                  <Grid container sx={{ width: 500, color: '#fff' }} spacing={0} columnSpacing={0}>
                                      <Grid item xs={5} sm={5} md={5}>
                                          {t('batchNo')}
                                      </Grid>
                                      {/* <Grid item xs={3} sm={3} md={3}>
                                        Expiry Date
                                    </Grid> */}
                                      <Grid item xs={4} sm={4} md={4} textAlign={"right"}>
                                          {t('usage')}
                                      </Grid>
                                      <Grid item xs={3} sm={3} md={3} textAlign={"right"}>
                                          {t('qty')}
                                      </Grid>
                                  </Grid>
                              </ListSubheader>
                              {
                                  getLatestVerifyOut().map((item, index) => {
                                      return (
                                            <MenuItem
                                                  key={index}
                                                  value={item.id}
                                                  sx={{
                                                      textTransform: 'capitalize',
                                                      px: 1.5,
                                                      fontSize: 14
                                                  }}
                                                  disableGutters
                                                  divider
                                            >
                                                <Grid container>
                                                    <Grid item xs={5} sm={5} md={5} textAlign={"left"}>
                                                        <ListItemText
                                                              primary={item?.custom_batch_no}
                                                              secondary={item?.expiry_date}
                                                        />
                                                    </Grid>
                                                    {/* <Grid item xs={3} sm={3} md={3}>
                                                    {item?.expiry_date}
                                                </Grid> */}
                                                    <Grid item xs={4} sm={4} md={4} textAlign={"right"}>

                                                        {
                                                            item?.usageQty ? "- ".concat(item?.usageQty): "-"
                                                        }

                                                    </Grid>
                                                    <Grid item xs={3} sm={3} md={3} textAlign={"right"}>
                                                        {item?.allowQty}
                                                    </Grid>
                                                </Grid>
                                            </MenuItem>
                                      )
                                  })
                              }
                          </Select>
                          <FormHelperText>
                              {
                                  errors?.verifyOut?.id
                              }
                          </FormHelperText>
                      </FormControl>
                  </Grid>
                  <Grid item md={6} sm={12} xs={12}>
                      {
                            values?.verifyOut?.id &&
                            <TextField
                                  disabled
                                  margin="dense"
                                  size="small"
                                  // autoFocus
                                  fullWidth
                                  name={"verifyOut.value"}
                                  label={t("availableQty")}
                                  type="text"
                                  variant="outlined"
                                  value={values?.verifyOut?.value ? values.verifyOut.value: "0"}
                                  onChange={handleChange}
                                  error={Boolean(errors?.verifyOut?.value)}
                                  helperText={errors?.verifyOut?.value}
                                  InputProps={{
                                      endAdornment: (
                                            <InputAdornment position="end">
                                                {` / ${parseFloat(values?.verifyOut?.maxQty)}`}
                                            </InputAdornment>
                                      ),
                                  }}
                            />
                      }
                  </Grid>
              </Grid>
        )
    }

    const RenderNew = () => {
        return (
              <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>

                      <Grid item xs={12} sm={12} md={12}>
                          <Divider textAlign={"center"}>
                              <Typography
                                    sx={{
                                        color: grey[400]
                                    }}
                              >
                                  {t('itemInformation')}
                              </Typography>
                          </Divider>
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                          <TextField
                                margin="dense"
                                size="small"
                                // autoFocus
                                fullWidth
                                label={t("itemName")}
                                type="text"
                                variant="outlined"
                                value={values?.itemName}
                                onChange={handleChange}
                                disabled
                          />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6}>
                          <TextField
                                margin="dense"
                                size="small"
                                // autoFocus
                                fullWidth
                                label={t("code")}
                                type="text"
                                variant="outlined"
                                value={values?.code}
                                onChange={handleChange}
                                disabled
                          />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12}>
                          <Divider textAlign={"center"}>
                              <Typography
                                    sx={{
                                        color: grey[400]
                                    }}
                              >
                                  {t('savedVerifedOut')}
                              </Typography>
                          </Divider>
                      </Grid>

                      <Grid item xs={6} sm={6} md={12}>
                          {
                              RenderVerifyOutSelection()
                          }
                      </Grid>

                      {
                            values?.verifyOut?.id &&
                            <>
                                <Grid item xs={12} sm={12} md={12}>
                                    <Divider textAlign={"center"}>
                                        <Typography
                                              sx={{
                                                  color: grey[400]
                                              }}
                                        >
                                            {t('allocation')}
                                        </Typography>
                                    </Divider>
                                </Grid>

                                <Grid item xs={6} sm={6} md={6}>
                                    <RenderRackSelect/>
                                </Grid>
                                <Grid item xs={6} sm={6} md={6}>
                                    <RenderSlotSelect/>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <TextField
                                          margin="dense"
                                          size="small"
                                          // autoFocus
                                          fullWidth
                                          name={"verifyQty.value"}
                                          label={t("qty")}
                                          type="text"
                                          variant="outlined"
                                          value={values?.verifyQty?.value}
                                          onChange={(e) => {
                                              let val = e.target.value
                                              setFieldValue(`verifyQty`, {
                                                  ...values.verifyQty,
                                                  value: val
                                              })

                                              // also set the selected value checking for verifyOut
                                              setFieldValue(`verifyOut`, {
                                                  ...values.verifyOut,
                                                  value: val
                                              })

                                          }}
                                          onFocus={event => {
                                              event.target.select();
                                          }}
                                          error={Boolean(errors?.verifyQty?.value)}
                                          helperText={errors?.verifyQty?.value}
                                          InputProps={{
                                              endAdornment: (
                                                    <InputAdornment position="end">
                                                        {` / ${parseFloat(values?.verifyQty?.maxQty)}`}
                                                    </InputAdornment>
                                              ),
                                          }}
                                    />
                                </Grid>
                            </>
                      }

                      <Grid item xs={12} sm={12} md={12}>
                          <Button
                                variant='contained'
                                fullWidth
                                type='submit'
                          >
                              <CommonIcons name={icons.save}/>
                              <Box sx={{ ml: 1 }}>
                                  {t('saveChanges')}
                              </Box>
                          </Button>
                      </Grid>
                  </Grid>
              </form>
        )
    }

    return (
          <Box
                sx={{
                    p: 2
                }}
          >
              {/* {JSON.stringify(values)} */}
              {/* {JSON.stringify(errors)} */}
              {
                  RenderNew()
              }

          </Box>
    )
}